/**
 * OVERRIDE Matomo.jsx
 * REASON: Implement opt-out tracking instead of opt-in, so Matomo runs by default without requiring user consent and only stops when the user explicitly opts out via the privacy settings page.
 * FILE: https://github.com/kitconcept/volto-dsgvo-banner/blob/3.0.1/packages/volto-dsgvo-banner/src/components/Banner/Matomo.jsx
 * VERSION: volto-dsgvo-banner v3.0.1
 * DATE: 13.05.2026
 * DEVELOPER: Jonas Piterek (kitconcept GmbH)
 */

import { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import config from '@plone/volto/registry';
import { injectLazyLibs } from '@plone/volto/helpers/Loadable/Loadable';

const Matomo = ({ matomoTracker }) => {
  const [cookies] = useCookies();
  // START CUSTOMIZATION
  const confirmTracking = !Number(cookies.optout_tracking);
  // END CUSTOMIZATION
  let tracker;

  if (__CLIENT__) {
    tracker = new matomoTracker.default({
      urlBase: config.settings.DSGVOBanner.tracker.urlBase,
      siteId: config.settings.DSGVOBanner.tracker.id,
    });
  }

  useEffect(() => {
    if (confirmTracking) {
      tracker.trackPageView();
    }
  }, [tracker, confirmTracking]);

  return null;
};

export default injectLazyLibs(['matomoTracker'])(Matomo);
